import React, { useState } from "react";
import FormHeaderBlock from "../../shared/FormHeaderBlock";
import { NextButton } from "../../shared/NextButton";
import BackButton from "../../shared/BackButton";
import WarningMessage from "../../shared/WarningMessage";

export default function Step10Interest({ onNext, onBack, formData }) {
  // Ensure formData is always an object
  const safeFormData = formData || {};

  // Ensure interests is always an array
  const [selectedInterests, setSelectedInterests] = useState(safeFormData.interests || []);
  const [error, setError] = useState("");

  const interestsOptions = [
    "Technology",
    "Education",
    "Sports",
    "Music",
    "Art",
    "Science",
    "Gaming",
    "Health",
  ];

  const toggleInterest = (interest) => {
    if (selectedInterests.includes(interest)) {
      setSelectedInterests(selectedInterests.filter((i) => i !== interest));
    } else {
      setSelectedInterests([...selectedInterests, interest]);
    }
    setError("");
  };

  const handleNext = () => {
    if (selectedInterests.length === 0) {
      setError("Please select at least one interest.");
      return;
    }

    onNext({
      ...safeFormData,
      interests: selectedInterests,
    });
  };

  return (
    <>
      <FormHeaderBlock title="Select your interests" />

      <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem", fontFamily:"Inter" }}>
        {interestsOptions.map((interest) => (
          <button
            key={interest}
            onClick={() => toggleInterest(interest)}
            style={{
              padding: "0.5rem 1rem",
              borderRadius: "20px",
              border: selectedInterests.includes(interest) ? "1.5px solid #3b82f6" : "1px solid #ccc",
              backgroundColor: selectedInterests.includes(interest) ? "#e0f2fe" : "#fff",
              cursor: "pointer",
            }}
          >
            {interest}
          </button>
        ))}
      </div>

      {error && <WarningMessage>{error}</WarningMessage>}

      <NextButton onClick={handleNext} disabled={selectedInterests.length === 0}>
        Next
      </NextButton>
      <BackButton onClick={onBack}>Back</BackButton>
    </>
  );
}
